import type { HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

/**
 * Loading placeholder. Animated subtle pulse over a card-tinted box; sits
 * comfortably on the dark background without adding contrast noise.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded bg-bg-card-hover/60", className)}
      {...props}
    />
  );
}
